import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./Home";
import Admin from "./Frontend/auth/Admin";
import {
  getToken,
  getProfile,
  isAdminRole,
  getStoredUserRole,
  clearAuthStorage,
} from "./Frontend/API/Api";
import "./App.css";

const App = () => {
  const [authState, setAuthState] = useState({ loading: true, isAdmin: false });

  useEffect(() => {
    const verifyAdminAccess = async () => {
      const token = getToken();
      if (!token) {
        setAuthState({ loading: false, isAdmin: false });
        return;
      }

      const storedRole = getStoredUserRole();
      if (isAdminRole(storedRole)) {
        setAuthState({ loading: false, isAdmin: true });
        return;
      }

      try {
        const profile = await getProfile();
        const role = profile?.role;

        if (isAdminRole(role)) {
          localStorage.setItem("userRole", role);
          setAuthState({ loading: false, isAdmin: true });
          return;
        }
      } catch (error) {
        console.error("Failed to verify admin access:", error);
      }

      clearAuthStorage();
      setAuthState({ loading: false, isAdmin: false });
    };

    verifyAdminAccess();
  }, []);

  if (authState.loading) {
    return null;
  }

  return (
    <Router>
      <Routes>
        <Route
          path="*"
          element={authState.isAdmin ? <Home /> : <Admin />}
        />
      </Routes>
    </Router>
  );
};

export default App;
